$(document).ready(function () {
    let $categoryLink = $('.page-template-template-catcare-new .filter-posts');
    let $h1 = $('.cat-care__banner__content h1');
    let $banner = $('.cat-care__banner');
    let $background = $('.cat-care__background');
    let $grid = $('.category__grid');
    let $items = $grid.children('.category__grid__item');
    let currentCat = 'all';
    let posts = [];
    let sortItems = (a, b) => {
        let an = a.getAttribute('data-order');
        let bn = b.getAttribute('data-order');

        if (an > bn) {
            return 1;
        }
        if (an < bn) {
            return -1;
        }
        return 0;
    };

    let filterPosts = function () {
        let cat = this.getAttribute('data-category');
        let sortedPosts = [];

        let categoryName = $(this).text();
        let color = $(this).attr('data-color');
        let bgColor = $(this).attr('data-bgcolor');
        let bannerImageUrl = $(this).attr('data-banner-image');

        $h1.text(categoryName);
        $banner.css('background-image', 'url(' + bannerImageUrl + ')');
        $background.css('background-color', bgColor);
        $categoryLink.toggleClass('is-active');

        $categoryLink.each(function () {
            $(this).toggleClass('is-active');
            $(this).css('background-color', '#fff');
        });

        $(this).css('background-color', color);

        $grid
            .fadeOut(300, function () {
                posts.map((item) => $(item).appendTo($grid));

                if (cat === 'all') {
                    $items.sort(sortItems).detach().appendTo($grid);
                } else {
                    $(`.category__grid__item:not([data-category=${cat}])`).each(function () {
                        sortedPosts.push($(this).detach());
                    });
                }

                posts = sortedPosts;
                currentCat = cat;
                $items.each(function () {
                    $(this).show();
                });
            })
            .fadeIn(300);
    };

    $categoryLink.click(filterPosts);
    $categoryLink.hover(
        function () {
            let color = $(this).attr('data-color');
            $(this).css('background-color', color);
        },
        function () {
            if (!$(this).hasClass('active')) {
                $(this).css('background-color', '#fff');
            }
        }
    );
});
